module.exports = __webpack_public_path__ + "img/u_chat-bubble-user.9c79dfbc.svg";